import { SurvicateEvents } from './constants'
import { VisitorTraits, SURVICATE_KEY, APP_NAME } from './'

class SurvicateUtils {
  static get survicate() {
    return window[SURVICATE_KEY]
  }

  static initSurvicate(userId: string) {
    if (this.survicate) {
      this.setVisitorTraits({ id: userId })
    } else {
      window.addEventListener(SurvicateEvents.SURVICATE_READY, () => {
        this.setVisitorTraits({ id: userId })
      })
    }
  }

  static setVisitorTraits(attributes: VisitorTraits) {
    if (this.survicate) {
      this.survicate.setVisitorTraits({
        system: APP_NAME,
        ...attributes
      })
    }
  }

  static showSurvey(surveyId: string) {
    if (this.survicate) {
      this.survicate.showSurvey(surveyId)
    }
  }
}

export default SurvicateUtils
